// src/data/products.js
import image1 from "../nillkin-case.webp";

import cauthangxoan from "./images/cauthangxoan.webp";
import cauthangxuongca from "./images/cauthangxuongca.webp";
import khungbaove from "./images/khungbaovesat.webp";
import kbvsuongca from "./images/kbvsuongca.webp";
import kbvcuaso from "./images/kbvcuaso.webp";


import cuasat01 from "./images/cuasat01.webp";
import cuasat02 from "./images/cuasat02.webp";
import cuasat03 from "./images/cuasat03.webp";
import cuasat04 from "./images/cuasat04.webp";
import cuasat05 from "./images/cuasat05.webp";
import cuasat06 from "./images/cuasat06.webp";
import cuasat07 from "./images/cuasat07.webp";
import cuasat08 from "./images/cuasat08.webp";
import cuasat09 from "./images/cuasat09.webp";
import cuasat10 from "./images/cuasat10.webp";
import cuasat11 from "./images/cuasat11.webp";
import cuasat12 from "./images/cuasat12.webp";
import cuasat13 from "./images/cuaSat13.webp";

import cuainox01 from "./images/cua-inox01.webp";
import cuainox02 from "./images/cua-inox02.webp";
import cuainox03 from "./images/cua-inox03.webp";

import hr1 from "./images/hangraosat1.webp";
import hr3 from "./images/hangraosat2.webp";
import hr2 from "./images/han-hang-rao-2.webp";
import lc1 from "./images/lan-can-nhom.webp";
import lc2 from "./images/lan-can-sat.webp";
import lc3 from "./images/lan-can-ban-cong-sat-2.webp";
import lc4 from "./images/lan-can-inox-12.webp";
import lc5 from "./images/lan-can-inox-13.webp";
import lc6 from "./images/lan-can-sat-14.webp";


import nx1 from "./images/nhaxe01.webp";
import nx2 from "./images/nhaxe02.webp";
import nx3 from "./images/nhaxe03.webp";
import nx4 from "./images/nhaxe04.webp";
import nx5 from "./images/nhaxe05.webp"

import BannerZero from "./images/banner-0.jpg";
import BannerOne from "./images/banner-1.jpg";
import BannerTwo from "./images/banner-2.jpg";
import BannerThree from "./images/banner-3.png";

export const banners = [
  { id: 0, image: BannerZero },
  { id: 1, image: lc4 },
  { id: 2, image: BannerTwo },
  { id: 3, image: BannerThree },
];

export const PRODUCTS = {
  1: { id: 1, name: "Cửa số 1", price: 10000, image: image1 },
  2: { id: 2, name: "Cửa số 2", price: 12000, image: image1 },
  3: { id: 3, name: "Cửa số 3", price: 15000, image: image1 },
  4: { id: 4, name: "Cửa số 4", price: 16000, image: image1 },
};

export const LANGDING_PRODUCTS = [
    { id: 1, image: cuasat01, title: "Cửa sắt", price: 10000, category: "Cửa" },
    { id: 14, image: cuainox01, title: "Cửa Inox", price: 12000, category: "Cửa" },
    { id: 25, image: hr1, title: "Hàng Rào", price: 15000, category: "Hàng rào" },
    { id: 32, image: lc1, title: "Lan Can", price: 16000, category: "Lan Can" },
    { id: 34, image: nx1, title: "Nhà xe", price: 17000, category: "Nhà xe" },
    { id: 16, image: cuainox03, title: "Cửa số 16", price: 20000, category: "Cửa" },
  ];

export const PRD_LIST = [
  { id: 1, image: cuasat01, name: "Cửa số 1", model: "1", price: 10000, manufacturer: "An Phát", category: "Cửa" },
  { id: 2, image: cuasat02, name: "Cửa số 2", model: "1", price: 12000, manufacturer: "An Phát", category: "Cửa" },
  { id: 3, image: cuasat03, name: "Cửa số 3", model: "1", price: 15000, manufacturer: "An Phát", category: "Cửa" },
  { id: 4, image: cuasat04, name: "Cửa số 4", model: "1", price: 17000, manufacturer: "An Phát", category: "Cửa" },
  { id: 5, image: cuasat05, name: "Cửa số 5", model: "1", price: 200000, manufacturer: "An Phát", category: "Cửa" },
  { id: 6, image: cuasat06, name: "Cửa số 6", model: "1", price: 10000, manufacturer: "An Phát", category: "Cửa" },
  { id: 7, image: cuasat07, name: "Cửa số 7", model: "1", price: 12000, manufacturer: "An Phát", category: "Cửa" },
  { id: 8, image: cuasat08, name: "Cửa số 8", model: "1", price: 15000, manufacturer: "An Phát", category: "Cửa" },
  { id: 9, image: cuasat09, name: "Cửa số 9", model: "1", price: 17000, manufacturer: "An Phát", category: "Cửa" },
  { id: 10, image: cuasat10, name: "Cửa số 10", model: "1", price: 200000, manufacturer: "An Phát", category: "Cửa" },
  { id: 11, image: cuasat11, name: "Cửa số 11", model: "1", price: 10000, manufacturer: "An Phát", category: "Cửa" },
  { id: 12, image: cuasat12, name: "Cửa số 12", model: "1", price: 10000, manufacturer: "An Phát", category: "Cửa" },
  { id: 13, image: cuasat13, name: "Cửa số 13", model: "1", price: 10000, manufacturer: "An Phát", category: "Cửa" },
  { id: 14, image: cuainox01, name: "Cửa số 14", model: "2", price: 12000, manufacturer: "An Phát", category: "Cửa" },
  { id: 15, image: cuainox02, name: "Cửa số 15", model: "2", price: 15000, manufacturer: "An Phát", category: "Cửa" },
  { id: 16, image: cuainox03, name: "Cửa số 16", model: "2", price: 12000, manufacturer: "An Phát", category: "Cửa" },

  { id: 17, image: cauthangxuongca, name: "Câu thang xương cá", model: "1", price: 10000, manufacturer: "An Phát", category: "Cầu Thang" },
  { id: 18, image: cauthangxoan, name: "Cầu thang xoắn", model: "2", price: 12000, manufacturer: "An Phát", category: "Cầu Thang" },

  { id: 21, image: khungbaove, name: "Khung Bảo Vệ", model: "2", price: 12000, manufacturer: "An Phát", category: "Khung Bảo Vệ" },
  { id: 22, image: kbvsuongca, name: "Khung bảo vệ xương cá", model: "2", price: 12000, manufacturer: "NAn Phátillkin", category: "Khung Bảo Vệ" },
  { id: 24, image: kbvcuaso, name: "Khung bảo vệ Cửa sổ", model: "2", price: 12000, manufacturer: "An Phát", category: "Khung Bảo Vệ" },

  { id: 25, image: hr1, name: "Hàng rao sắt", model: "1", price: 12000, manufacturer: "An Phát", category: "Hàng rào" },
  { id: 26, image: hr2, name: "Hàng rao sắt", model: "1", price: 12000, manufacturer: "An Phát", category: "Hàng rào" },
  { id: 27, image: hr3, name: "Hàng rao sắt", model: "1", price: 12000, manufacturer: "Nillkin", category: "Hàng rào" },

  { id: 28, image: lc3, name: "Lan Can", model: "2", price: 12000, manufacturer: "An Phát", category: "Lan Can" },
  { id: 29, image: lc4, name: "Lan can inox", model: "1", price: 16000, manufacturer: "An Phát", category: "Lan Can" },
  { id: 30, image: lc5, name: "Lan can inox", model: "2", price: 17000, manufacturer: "An Phát", category: "Lan Can" },
  { id: 31, image: lc6, name: "Lan can sắt", model: "1", price: 200000, manufacturer: "An Phát", category: "Lan Can" },
  { id: 32, image: lc1, name: "Lan can nhôm", model: "3", price: 17000, manufacturer: "An Phát", category: "Lan Can" },
  { id: 33, image: lc2, name: "Lan can sắt", model: "1", price: 200000, manufacturer: "An Phát", category: "Lan Can" },

  
  { id: 34, image: nx1, name: "Nhà xe 01", model: "1", price: 16000, manufacturer: "An Phát", category: "Nhà xe" },
  { id: 35, image: nx2, name: "Nhà xe 02", model: "2", price: 17000, manufacturer: "An Phát", category: "Nhà xe" },
  { id: 36, image: nx3, name: "Nhà xe 03", model: "1", price: 200000, manufacturer: "An Phát", category: "Nhà xe" },
  { id: 37, image: nx4, name: "Nhà xe 04", model: "3", price: 17000, manufacturer: "An Phát", category: "Nhà xe" },
  { id: 38, image: nx5, name: "Nhà xe 05", model: "1", price: 200000, manufacturer: "An Phát", category: "Nhà xe" },

  
  
];

// Nếu muốn duyệt dạng mảng cho dễ (ví dụ .map())
export const PRODUCT_LIST = Object.values(PRODUCTS);
